module.exports = __webpack_public_path__ + "img/renzhengshibai.42b5705a.png";